import http from "src/common/http";
import {DEVELOPMENT_URL, DASHBOARD_DETAILS, GET_MONTHLY_SALES, DELETE_CUSTOMER, DELETE_RIDER} from "../constants/apiUrl";

const dashboard = () => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + DASHBOARD_DETAILS, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const getMonthlySales = () => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_MONTHLY_SALES, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };
  const deleteCustomer = (customerId) => {
    const user = window.sessionStorage.getItem('token');
   
    return http
      .delete(DEVELOPMENT_URL + DELETE_CUSTOMER+customerId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };

  const deleteRider = (riderId) => {
    const user = window.sessionStorage.getItem('token');
   
    return http
      .delete(DEVELOPMENT_URL + DELETE_RIDER+riderId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };
  export default {dashboard, getMonthlySales, deleteCustomer, deleteRider};